export type BottomTabRoute = {
	name: string;
	title: string;
	icon: { default: string; selected: string };
	enabled: boolean;
	custom?: boolean;
};

export type BottomTab = {
	name: string;
	title: string;
	icon: { default: string; selected: string };
	enabled: boolean;
	custom: boolean;
};

export type BuildBottomTabsParams = {
	navigationRoutes: BottomTabRoute[];
	showStudyPackAsHome: boolean;
	practiceTestProductNumericId?: number;
	practiceTestEnabled?: { web: boolean; mobile: boolean };
	isWebPlatform: boolean;
};

export const buildBottomTabs = ({
	navigationRoutes,
	showStudyPackAsHome,
	practiceTestProductNumericId,
	practiceTestEnabled,
	isWebPlatform,
}: BuildBottomTabsParams): BottomTab[] => {
	const practiceTestTabEnabled =
		!!practiceTestProductNumericId &&
		(isWebPlatform
			? !!practiceTestEnabled?.web
			: !!practiceTestEnabled?.mobile);

	const normalize = (r: BottomTabRoute): BottomTab => ({
		...r,
		custom: r.custom ?? false,
	});

	const showsMoreRoute = navigationRoutes.some(
		(r) => r.name === "more" && r.enabled,
	);

	const tabs: BottomTab[] = [
		...navigationRoutes.slice(0, 1).map(normalize),
		{
			name: "practice-tests",
			icon: { default: "clipboard-text-outline", selected: "clipboard-text" },
			title: "Practice Tests",
			enabled: practiceTestTabEnabled,
			custom: false,
		},
		...navigationRoutes.slice(1).map(normalize),
		{
			name: "account/settings",
			icon: { default: "account-outline", selected: "account" },
			title: "Account",
			enabled: !showsMoreRoute,
			custom: false,
		},
	];

	return tabs.map((tab) => {
		if (tab.name === "home" && showStudyPackAsHome) {
			return {
				...tab,
				title: "Study-Pack",
				icon: { default: "study-pack-outline", selected: "study-pack" },
				custom: true,
			};
		}
		return tab;
	});
};
